export enum StatusMode {
  FullLockdown = 'fullLockdown',
  Operational = 'operational',
  GlobalMaintenanceBanner = 'globalMaintenanceBanner',
  SecuredMaintenanceBanner = 'securedMaintenanceBanner',
}

export type BannerSeverity = 'INFO' | 'WARNING';

export interface AppStatusConfig {
  statusMode: StatusMode;
  bannerMessage: string;
  bannerSeverity: BannerSeverity;
  lockdownTitle: string;
  lockdownMessage: string;
  lockdownShowReloadButton: boolean;
}

export const defaultAppStatusConfig: AppStatusConfig = {
  statusMode: StatusMode.Operational,
  bannerMessage: '',
  bannerSeverity: 'INFO',
  lockdownTitle: '',
  lockdownMessage: '',
  lockdownShowReloadButton: false,
};
